import React, { FC } from 'react';

import {
  default as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps
} from '@material-ui/core/CircularProgress';

export interface CircularProgressProps extends MuiCircularProgressProps {
  dataTest?: string;
  /**
   * @deprecated Please use dataTest property instead
   */
  'data-test'?: undefined;
}

export const CircularProgress: FC<React.PropsWithChildren<CircularProgressProps>> = ({ dataTest, ...props }) => (
  <MuiCircularProgress data-test={dataTest} {...props} />
);
